import * as React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import DashboardHome from "./pages/Dashboard/DashboardHome";
import PrivateRoute from  "./pages/PrivateRoute";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Logout from "./pages/Logout";




function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
        
          {/* <Route path="/:slug" element={
            <WebinarProvider>
              <WebinarHome />
            </WebinarProvider>
          } />
          <Route path="/live/:slug" element={<Live />} /> */}
         

          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/logoutp" element={<Logout />} />

          <Route
            path="/dashboard"
            element={
              <PrivateRoute allowedRoles={["admin"]}> 
                <DashboardHome/>
              </PrivateRoute>
            }
          />
        
        </Routes>
      </Router>
    </div>
  );
}

export default App;
